import React from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";

//import { Navigate } from 'react-router-dom';

import RiderWiseOrderTableView from "./RiderWiseOrderTableView";

const RiderWiseOrderDetails = ({ modalShow, setModalShow, isTitle, reactTableData }) => {

    // const [isRedirect, setIsRedirect] = useState(false);

    // if (isRedirect) {
    //     window.location.reload();
    //     return <Navigate to="/web_app/pnd_hub/view" />;
    // }
    let Icon;

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }


    return (
        <div >
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4 className="text-modal  modal__title mt-1 text-uppercase"

                    >
                        {isTitle}
                    </h4>
                </div>

                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                                <span
                                    className="account__logo-accent text-light"> */}
                        {/* form  */}
                        <RiderWiseOrderTableView reactTableData={reactTableData} />{/* 
                                </span>
                            </span> */}
                    </div>

                </ModalBody>

            </Modal>


        </div>
    );
};


export default connect((state) => ({
    rtl: state.rtl,
}))(RiderWiseOrderDetails);
